import { defineStore } from 'pinia';
import {
  addSubject,
  editSubject,
  exportSubject,
  getAllSubjects,
  getSubjectById,
  importSubject,
} from '@/services/subjectsService';
import router from '@/router';

export const useSubjectStore = defineStore('subject', {
  state: () => ({
    selectedSubject: { name: '', identifier: '' } as SubjectType,
    allSubjects: [] as SubjectType[],
  }),
  getters: {
    getAllSubjects(state) {
      return state.allSubjects.sort((a, b) => a.name.localeCompare(b.name));
    },
    hasSelectedSubject(state): boolean {
      return state.selectedSubject.identifier.trim() !== '';
    },
    getSelectedSubject(state): SubjectType {
      return state.selectedSubject;
    },
  },
  actions: {
    async initializeStore() {
      await this.fetchSelectedSubject();
    },
    setSelectedSubject(subject: SubjectType) {
      this.selectedSubject = subject;
    },
    async fetchAllSubjects() {
      this.allSubjects = await getAllSubjects();
    },
    async fetchSelectedSubject() {
      const selectedSubjectId = localStorage.getItem('selectedSubjectIdentifier');
      if (selectedSubjectId == null) {
        await router.push({ name: 'landing' });
      } else {
        this.selectedSubject = await getSubjectById(selectedSubjectId);
      }
    },
    async addSubject(newSubject: SubjectType) {
      return await addSubject(newSubject);
    },
    async editSubject(subjectIdent: string, editedSubject: SubjectType) {
      return await editSubject(subjectIdent, editedSubject);
    },

    async importSubject(subjectIdent: string, file: any) {
      return await importSubject(subjectIdent, file);
    },

    async exportSubject(subjectIdent: string) {
      return await exportSubject(subjectIdent);
    },
  },
});
